

























import { Component, Vue } from 'vue-property-decorator';
import Nullable from '@/types/nullable';
import { Singleton as AuthService } from '@/services/authService';
import { vxm } from '@/stores';
import moment from 'moment';

@Component({})
export default class Home extends Vue {
  private loading: boolean = false;
  private username: string = "";
  private password: string = "";
  private errorMessage: Nullable<string> = null;

  async login(){
    this.loading = true;

    try {
      const loginResult = await AuthService.authenticate(this.username.trim(), this.password);
      if(loginResult.success){
        this.$router.push({ name: "home" });

        this.showWelcomeMessage();
      } else if(loginResult.message) {
        this.errorMessage = loginResult.message;
      } else {
        this.errorMessage = "Login failed.";
      }
    } catch(err){
      this.errorMessage = err;
    }

    this.loading = false;
  }

  showWelcomeMessage(){
    let welcomeMessage = `${this.getAppropriateGreeting()} ${vxm.user.displayName}`;

    vxm.navigation.showSnackbar({
      message: welcomeMessage, 
      timeout: 2000,
      color: 'primary'
    });        
  }

  getAppropriateGreeting(){
    let now = moment();
    let noon = moment().hours(12).minutes(0).seconds(0).milliseconds(0);
    let fivePm = moment().hours(17).minutes(0).seconds(0).milliseconds(0);

    if(now < noon){
      return "Good Morning";
    } else if(now < fivePm){
      return "Good Afternoon";
    } else {
      return "Good Evening";
    }
  }

  hideError(){
    this.errorMessage = null;
  }

  logout(){
    AuthService.clearAuth();
  }
}
